import { navigateInternally } from 'utils/bolt/index';

export function loadMap() {
	navigateInternally('map');
	const tryNavigateToLocation = () => {
		if (window.__manualMapReload === 'function') {
			window.__manualMapReload();
			window.navToLocation('map');
		} else {
			// requestAnimationFrame(tryNavigateToLocation);
			window.__manualMapReload();
			if (window.animateToMapDetail) setTimeout(window.animateToMapDetail, 500);
		}
	};
	return tryNavigateToLocation();
}